import "./magicProgress.scss";

const MagicProgress = (props) => {
  const { ranges, currentValue } = props;

  let currentValueRangeIndex = ranges.findIndex(
    (range) => currentValue >= range.from && currentValue <= range.to
  );
  if (currentValue > 40 && currentValueRangeIndex === -1) {
    currentValueRangeIndex = ranges.length - 1;
  }
  const togglePosition = (currentValueRangeIndex * 100) / ranges.length;
  const currentValueRange = ranges[currentValueRangeIndex];

  const bars = ranges.map((range, rangeIndex) => {
    return (
      <div
        className="bar"
        key={rangeIndex}
        style={{
          width: `${getPercentage(range)}%`,
          backgroundColor: range.color,
        }}
      >
        <span className="bar-title">{range.title}</span>
      </div>
    );
  });

  return (
    <div className="magic-progress">
      <div className="bars">{bars}</div>
      {currentValue && currentValue > 0 ? (
        <div className="toggler" style={{ left: `${togglePosition}%` }}></div>
      ) : (
        ""
      )}
      {currentValue && currentValue > 0 ? (
        <div
          className="toggler-content"
          style={{
            left: `${togglePosition}%`,
            backgroundColor: currentValueRange.color,
          }}
        >
          BMI شما :{currentValue}
        </div>
      ) : (
        ""
      )}
    </div>
  );

  function getPercentage(range) {
    return 100 / ranges.length;
  }
};

export default MagicProgress;
